import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-industry-profile-card',
  templateUrl: './industry-profile-card.component.html',
  styleUrls: ['./industry-profile-card.component.css']
})
export class IndustryProfileCardComponent implements OnInit {

  exccedanceCardLoader = false;
  exceedanceCardDetail = [];
  countCardDetail = [];
  intervalList = [];
  exceedanceGraphCount = [];
  industryId;
  totalExceedance = 0;
  responseCardDetail = [];
  route:string;
  exceedanceList = [];
  exceedanceListPopupLoader = false;
  exceedanceGraph = false;
  detailsCardLoader = false;
  detailsResponseCardLoader = false;
  exceedanceChart: Chart;
  archive = false;
  countDuration = 1;
  countFrom = 0;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.activeroute.queryParams.subscribe(params => {
      this.industryId = atob(params['industry_id']);
      if(params['archive']){
        this.archive = params['archive'];
      }
    });

    this.getExccedanceCardDetail();
    this.getDetailsCount();
    this.getResponseCount();
  }

  getDetailsCount(){

    this.detailsCardLoader = true;
    this.route  = 'get-profile-card-count-details';
    const token    = localStorage.getItem('userToken');
    this.countCardDetail = [];

    let data = {
                'industry_id':this.industryId,
                'is_archive':this.archive
                };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {




      if(response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.countCardDetail= response.data;
        this.detailsCardLoader = false;
      }

    });

  }

  getExceedanceList(){
    this.exceedanceListPopupLoader = true;

    this.route  = 'get-exceedance-list';
    const token    = localStorage.getItem('userToken');
    this.exceedanceList = [];

    let data = {'industry_id':this.industryId, 'is_archive':this.archive};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.exceedanceList= response.data;
        this.exceedanceListPopupLoader = false;
      }

    });
  }


  getResponseCount(){

    this.detailsResponseCardLoader = true;
    this.route  = 'get-profile-card-response-count-details';
    const token    = localStorage.getItem('userToken');
    this.responseCardDetail = [];

    let data = {'industry_id':this.industryId, 'is_archive':this.archive};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.responseCardDetail= response.data;
        this.detailsResponseCardLoader = false;
      }

    });

  }


  getExccedanceCardDetail(){
    this.exccedanceCardLoader = true;
    this.route  = 'get-profile-exceedance-list';
    const token    = localStorage.getItem('userToken');
    this.exceedanceCardDetail = [];

    let data = {'industry_id':this.industryId, 'is_archive':this.archive};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.exceedanceCardDetail = response.exceedanceRow;
        this.totalExceedance = response.totalExceedanceCount;

        if(response.exceedanceCount){
          this.exceedanceGraph = true;

          for(let exceedance in this.exceedanceCardDetail) {
            this.intervalList.push(exceedance);
            this.exceedanceGraphCount.push(this.exceedanceCardDetail[exceedance]);
          }
          this.drawExceedanceGraph(this.intervalList,this.exceedanceGraphCount);

        }else{
          this.exccedanceCardLoader = false;
          this.exceedanceGraph = false;
        }

      }

    });
  }

  drawExceedanceGraph(intervalList, exceedanceGraphCount){

    let barChartLocal = new Chart({
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: intervalList,
        labels: {
          rotation: -45,
          style: {
            fontSize: '8px'
          }
        }
      },
      yAxis: {
        min: 0,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        title: {
          text: ''
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold'
          }
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{point.y} Exceedance'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false
          }
        }
      },
      series: [{
        name: 'Vendor',
        data: exceedanceGraphCount,
        type: 'line',
      }]
    });
    this.exceedanceChart = barChartLocal;
    this.exccedanceCardLoader = false;
  }

}
